(ns manage.campaign.hooks
  (:require [common.queries :refer [use-query]]
            [common.resource.query.adset :refer [adsets-query]]
            [common.resource.query.campaign :as cq]
            [manage.adset.util :as adset-util]
            [uix.core :refer [defhook]]
            [uix.re-frame :refer [use-subscribe]]))

(defhook use-campaign-channel-options []
  (let [{:keys [campaign-id]} (use-subscribe [:url-context])
        {adsets :data} (use-query (adsets-query {:campaign-id campaign-id}))
        campaign-channels (set (map :channel adsets))]
    (filter #(contains? campaign-channels (:value %)) adset-util/channel-options)))

(defhook use-wpp-open-project []
  (let [{:keys [advertiser-id]} (use-subscribe [:url-context])
        {campaigns :data} (use-query (cq/campaigns-query {:advertiser-id advertiser-id}))
        project-id (use-subscribe [:common.os/project-id])
        mapped-campaigns (->> campaigns
                              (filter #(-> %
                                           :WPPOSProjectIds
                                           set
                                           (contains? project-id))))
        mapped-campaign (first mapped-campaigns)
        os-enabled? (use-subscribe [:common.os/enabled])
        os-project-available? (and os-enabled? (not (nil? project-id)))]
    {:os-enabled? os-enabled?
     :os-project-available? os-project-available?
     :mapped-campaign? (some? mapped-campaign)
     :mapped-campaign mapped-campaign
     :project-id project-id}))
